module.exports = __webpack_public_path__ + "img/strict.1452b40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/setting-wizard/strict.svg
// module id = fSFW
// module chunks = 1